import { Typography, Box } from "@mui/material";
import { EditableInputDisplay } from "../../EditableComponents";
import { useState } from "react";

export default function NotePatient({ _patient, editMode, setParentValue }) {
  const [note, setNote] = useState(_patient.note);

  return (
    <Box
      sx={{
        display: "grid",
        margin: "auto",
        gridTemplateColumns: "1fr 1fr",
        width: "100%",
      }}
    >
      <Box sx={{ margin: "10px" }}>
        {note || editMode ? (
          <EditableInputDisplay
            id={"note"}
            label={"Note:"}
            initialValue={note}
            setEditMode={editMode}
            inputMode={"text"}
            setParentValue={setParentValue}
          />
        ) : (
          <Typography>Nessuna nota salvata</Typography>
        )}
      </Box>
    </Box>
  );
}
